export default "__VITE_ASSET__BRZRhTbR__"